import React from 'react';
import { useSelector } from 'react-redux';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { TcsmStates } from '../../../root/tcsm-model';
import { hasNoPlan } from '../helpers/pods-helper-functions';
import { MyCpgPodsSettings, MyCpgPodsState } from '../mycpg-pod-models';
import { AnnuityPlanPod } from './annuity-plan-pod';
import { DisabilityPlanPod } from './disability-plan-pod';
import { EmploymentPod } from './employment-pod';
import { HealthPlanPod } from './health-plan-pod';
import { LifePlanPod } from './life-plan-pod';
import { DcPlanPod } from './pension-dc-plan-pod';
import { PensionPlanPod } from './pension-plan-pod';
import { PodGrid } from './pod-grid';
import { RsvpPod } from './rsvp-pods';

interface Props {
	dashboardMode?: boolean
	noAccessMessage?: string;
}

export function RenderPods(props: Props) {

	const { dashboardMode, noAccessMessage } = props;

	const podsState = useSelector<TcsmStates, MyCpgPodsState>(state => state.mycpgPodsState);
	const settings = useSelector<TcsmStates, MyCpgPodsSettings>(state => state.epiProps?.podsSettingsState?.epiContent);

	const noPlan = hasNoPlan(podsState);


	if (dashboardMode) return null;

	if (settings?.hidePods) {
		return <DividerSection removeDivider><WysiwygWithReactLink content={settings?.hidePodMessage} /></DividerSection>;
	}

	if (!podsState?.pods?.status) {
		return <DividerSection removeDivider><WysiwygWithReactLink content={noAccessMessage || settings?.noAccessMessage} /></DividerSection>;
	}

	return (
		podsState?.podsError ?
			<DividerSection removeDivider><WysiwygWithReactLink content={settings?.podErrorMessage} /> </DividerSection> :
			<>
				{
					noPlan ?
						<DividerSection sectionText={settings?.noPlanTitle} removeDivider><WysiwygWithReactLink content={settings?.noPlanMessage} /></DividerSection> :
						<>
							{noAccessMessage && <DividerSection removeDivider><WysiwygWithReactLink content={noAccessMessage} /></DividerSection>}
							<PodGrid settings={settings} >
								<PensionPlanPod settings={settings} />
								<DcPlanPod settings={settings} />
								<RsvpPod settings={settings} />
								<HealthPlanPod settings={settings} />
								<LifePlanPod settings={settings} />
								<AnnuityPlanPod settings={settings} />
								<DisabilityPlanPod settings={settings} />
								<EmploymentPod settings={settings} />
							</PodGrid>
						</>
				}
			</>
	);
}


RenderPods.defaultProps = {
	dashboardMode: false,
	noAccessMessage: null,
};